import { render, staticRenderFns } from "./TableActionRenderer.vue?vue&type=template&id=ef824e66&"
import script from "./TableActionRenderer.vue?vue&type=script&lang=ts&"
export * from "./TableActionRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./TableActionRenderer.vue?vue&type=style&index=0&id=ef824e66&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports